import BaseApi from "../../../services/Api";
import {toast} from "react-toastify";
import Swal from "sweetalert2";
import React, {useEffect, useState} from "react";
import Tooltip from "../../Popups/Tooltip";
import {Modal, Spinner} from "react-bootstrap";
import Button from "../../Layout/Button";
import style from "./style.module.css"


const ModalBanner = ({
  idBanner, onUpdate, onCreate, children
}) => {
  const [isLoading, setLoading] = React.useState(true);
  const [isSaving, setSaving] = React.useState(true);
  const [isShow, setShowModal] = React.useState(false);

  const [title, setTitle] = useState('');
  const [image, setImage] = useState(null);
  const [updateImage, setUpdateImage] = useState(null);
  const [calloutPhrase, setCalloutPhrase] = React.useState('');
  const [buttonText, setButtonText] = React.useState('');
  const [buttonLink, setButtonLink] = React.useState('');

  const [currentImage, setCurrentImage] = useState(null);

  const buildFormData = () =>{
    const formData = new FormData();
    if(title!=undefined){

      formData.append("title", title);
    }
    if(calloutPhrase!=undefined){

      formData.append("callout_phrase", calloutPhrase);
    }
    if(buttonText!=undefined){

      formData.append("button_text", buttonText);
    }
    if(buttonLink!=undefined){

      formData.append("button_link", buttonLink);
    }

    if(idBanner) {
        formData.append('_method', 'PUT')
        if (updateImage) {
            formData.append("image", updateImage);
        }
    } else{
        if (image){
            formData.append("image", image);
        }
    }
    return formData
  }

  const formData = buildFormData();

  const onSave = () => {
    Swal.fire({
      title: 'Certeza que deseja salvar?',
      text: "Você não conseguirá reverter isso!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Salvar',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: "#198754",
      cancelButtonColor: "#d33",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        submitData();
      } else if (
          result.dismiss === Swal.DismissReason.cancel
      ) {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Operação cancelada!',
          showConfirmButton: false,
          timer: 1500
        })
      }
    })
  }


  const submitData = () => {
    setSaving(true);
    if (idBanner) {
      BaseApi.post(`/banner/${idBanner}`, formData).then(res => {
        setSaving(false);
        setShowModal(false);
        toast.success('Banner criado com sucesso!');
        onUpdate && onUpdate(res.data);
      }).then(() => {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Dados salvos com sucesso!',
          showConfirmButton: false,
          timer: 1500
        }).then(() => window.location.reload(false))
      }).catch(err => {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Ocorreu um erro ao atualizar banner.',
          showConfirmButton: false,
          timer: 1500
        })
        setSaving(false);
      })
    }
    else {
      BaseApi.post('/banner', formData).then(res => {
        setSaving(false);
        setShowModal(false);
        toast.success('Banner atualizado com sucesso');
        onCreate && onCreate(res.data);
      }).then(() => {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Dados salvos com sucesso!',
          showConfirmButton: false,
          timer: 1500
        })
            .then(() => window.location.reload(false))
      }).catch(err => {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Ocorreu um erro ao salvar a banner.',
          showConfirmButton: false,
          timer: 1500
        })
        setSaving(false);
      })
    }
  }

  const handleClose = () => {
    setShowModal(false);
  }

  const handleChangeImage = (e) => {
    const selectedImage = e.target.files[0];
    if (idBanner){
      if (selectedImage)  {
        setUpdateImage(selectedImage);
        setCurrentImage(selectedImage);
      }
    }
    else {
      if (selectedImage)  {
        setImage(selectedImage);
        setCurrentImage(selectedImage);
      }
    }
};

  const requestData = () => {
    setLoading(true);
    BaseApi.get(`/banner${idBanner ? `/${idBanner}` : ''}`).then(res => {
      let data = res.data;
      setTitle(data.title);
      setImage(data.image)
      setCurrentImage(data.image);
      setCalloutPhrase(data.callout_phrase);
      setButtonText(data.button_text);
      setButtonLink(data.button_link);
      setLoading(false);
      setSaving(false);
    }).catch(err => {
      Swal.fire('Oops!', err?.data?.errors?.[0] || err?.data?.message || 'Ocorreu um erro ao carregar esta ação ou o banner não foi encontrado.', 'error');
      setShowModal(false);
    })
  }

  useEffect(() => {
    if(isShow) {
      requestData();
    } else {
      setTitle('');
      setImage(null);
      setUpdateImage(null);
      setCalloutPhrase('');
      setButtonLink('');
      setButtonText('');
      setLoading(true);
      setSaving(true);
    }
  }, [isShow])

  return (
    <>
      {children &&
        React.cloneElement(children, { onClick: (e) => setShowModal(true) })}
      {!children && (
        <Tooltip text={idBanner ? "Editar banner" : "Criar banner"}>
          <button
            className={`btn btn-${idBanner ? "warning" : ""} text-white fa-bold`}
            onClick={(e) => setShowModal(true)}
          >
            <i className={`bi bi-${idBanner ? "person-gear" : "plus"}`}></i>
          </button>
        </Tooltip>
      )}
      <Modal
        centered
        scrollable
        onHide={handleClose}
        show={isShow}
        animation={true}
        size="md"
      >
        <Modal.Header closeButton>
          <Modal.Title>{idBanner ? "Editar" : "Criar"} banner</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex align-items-center justify-content-center">
            {isLoading && (
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            )}
          </div>
          {!isLoading && (
            <>
              <div className="row">
                <div className="form-group mb-3">
                  <label className={style.required} htmlFor="title">Título </label> 
                  <input
                    type="text"
                    className="form-control"
                    id="title"
                    placeholder="Insira o título"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    
                  />
                </div>
                <div className="form-group mb-3">
                  <label className={style.required} htmlFor="calloutPhrase">Frase de destaque </label>
                  <textarea
                    type="text"
                    className="form-control"
                    id="callout_phrase"
                    placeholder="Insira a frase de destaque"
                    value={calloutPhrase}
                    onChange={(e) => setCalloutPhrase(e.target.value)}
                  />
                </div>
                <div className="form-group mb-3">
                  <label htmlFor="buttonText">Texto do botão </label>
                  <input
                    type="text"
                    className="form-control"
                    id="button_text"
                    placeholder="Texto botão"
                    maxLength={11}
                    value={buttonText}
                    onChange={(e) => setButtonText(e.target.value)}
                  />
                </div>
                <div className="form-group mb-3">
                  <label htmlFor="buttonLink">Link do botão </label>
                  <input
                    type="url"
                    className="form-control"
                    id="button_link"
                    placeholder="Insira um link para o botão"
                    value={buttonLink}
                    onChange={(e) => setButtonLink(e.target.value)}
                  />
                </div>

                <div className="form-group mb-3">
                  <label className={style.required} htmlFor="image">Imagem </label>

                  <input type="file" accept="image/*"
                  className="form-control"
                  
                  onChange={handleChangeImage} />
                  
                  {idBanner ? (
                    <div className="d-flex justify-content-center align-items-center mt-2">
                      <img
                        src={currentImage instanceof File ? URL.createObjectURL(currentImage) : currentImage}
                        alt="imagem"
                        style={{ minWidth: 250, width: 350, objectFit: 'cover' }}
                      />
                    </div>
                  ) : 
                    null
                  }

                  {currentImage && !idBanner && (
                    <div className="d-flex justify-content-center align-items-center mt-2">
                      {idBanner ? <img src={currentImage} alt="imagem" style={{minWidth: 250, width: 350, objectFit: "cover"}}/>
                        : <img src={URL.createObjectURL(currentImage)} alt="imagem" style={{minWidth: 250, width: 350, objectFit: "cover"}}/>
                      }
                      </div>
                    )
                  }
                </div>


              </div>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex align-items-center w-100">
            <div className="d-block me-auto"></div>
            <div className="d-block ms-auto">
              <button
                className="btn btn-danger text-white me-2"
                onClick={handleClose}
              >
                Close
              </button>
              <Button
                loading={isSaving}
                onClick={onSave}
                className="btn btn-success text-white"
              >
                {idBanner ? "Editar" : "Criar"}
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ModalBanner;